import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "@/components/brand/BrandAssets";

const BACK = { lv: "Uz sākumu", ru: "На главную", en: "Back to home" };

export const InfoPageHeader = ({ language, setLanguage, title, subtitle, testId }) => {
  const navigate = useNavigate();
  const langs = [["lv", "LV"], ["ru", "RU"], ["en", "EN"]];
  return (
    <header className="border-b border-[#E7E5E4]" data-testid={testId}>
      <div className="max-w-[1100px] mx-auto px-5 sm:px-8 pt-6 pb-12 sm:pb-16">
        <div className="flex items-center justify-between gap-4">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="rz-link inline-flex items-center gap-2 min-h-[44px] text-[0.7rem] font-medium tracking-[0.22em] uppercase text-[#78716C]"
            data-testid="info-back-home"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
            {BACK[language] || BACK.lv}
          </button>
          <a href="/" className="hidden sm:block" aria-label="Roze di Napoli"><Wordmark size="nav" tone="dark" /></a>
          <div className="inline-flex border border-[#E7E5E4]" role="group" aria-label="Language" data-testid="info-language-switch">
            {langs.map(([code, label]) => (
              <button
                key={code}
                onClick={() => setLanguage(code)}
                aria-pressed={language === code}
                className={`min-w-[44px] min-h-[44px] px-3 text-[0.7rem] font-medium tracking-[0.18em] transition-colors ${language === code ? "bg-[#1C1917] text-[#FDFBF7]" : "text-[#57534E] hover:bg-[#F5F2EC]"}`}
                data-testid={`info-lang-${code}`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-12 sm:mt-16 max-w-[760px]">
          <p className="rz-eyebrow m-0 mb-5">Roze di Napoli</p>
          <h1 className="font-display text-[2.4rem] sm:text-[3.4rem] leading-[1.02] text-[#1C1917] m-0" data-testid="info-page-title">{title}</h1>
          {subtitle && <p className="font-display text-[1.15rem] sm:text-[1.3rem] text-[#57534E] mt-6 mb-0 leading-[1.6]">{subtitle}</p>}
        </div>
      </div>
    </header>
  );
};
